import React from 'react';
import "./Exif.css"
import {Button} from "antd";
import {CloseOutlined} from "@ant-design/icons";
import Sha1Section from "./Sha1Section";
import ImageExifSection from "./ImageExifSection";
import ImageDisplaySection from "./ImageDisplaySection";
import ImageFilteredExifSection from "./ImageFilteredExifSection";

const Exif = ({exifInfo, onClose}) => {

    return (<div className="exif-container">
        <Button style={{float: "right"}} shape="circle" icon={<CloseOutlined/>}
                onClick={onClose}/>
        <ImageFilteredExifSection exifInfo={exifInfo}/>
        <ImageExifSection exifInfo={exifInfo}/>
        <Sha1Section exifInfo={exifInfo}/>
        <ImageDisplaySection exifInfo={exifInfo}/>
    </div>);
}

export default Exif;


// WEBPACK FOOTER //
// ./src/exif/Exif.js